<script setup lang="ts">
import type { UploadingFile } from '#layers/assets/stores/upload';
import { ButtonRemove } from '#layers/ui';

defineProps<{
	upload: UploadingFile;
}>();

defineEmits<{
	abort: [];
}>();
</script>

<template>
	<div class="flex min-h-30 flex-col items-center justify-center gap-4 rounded-lg border">
		<div class="flex min-w-96 items-center justify-between gap-2 rounded-sm border border-dashed bg-default px-3 py-1">
			<FileInfo :file="upload.file" />
			<DTooltip :text="$t('common.cancel')">
				<ButtonRemove :trash-bin="false" with-leading-icon square @click="$emit('abort')" />
			</DTooltip>
		</div>
		<div class="flex items-center gap-2">
			<DSpinner class="size-6" />
			<span class="text-sm text-dimmed">
				{{ $t('upload.status.uploading') }}
			</span>
		</div>
	</div>
</template>
